"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const calculateTotal = (employee, type) => {
  let result = 0;
  let arr = [];
  if (type === 'time') {
    result = Number(employee.yearlyNominalTime) - Number(employee.vacation);
    return result.toFixed(2);
  }
  if (type === 'yearlyPresenceTime') {
    const time = Number(employee.yearlyNominalTime) - Number(employee.vacation);
    result = time + Number(employee.overUnderTime);
    employee.yearlyPresenceTime = result.toFixed(2);
    arr = ['personalHolidays', 'illnessAccidentDoctor', 'militaryCivilService', 'maternityPaternityLeave', 'publicOffices', 'vocationalSchool'];
    arr.forEach(param => {
      if (!isNaN(employee[param])) result -= Number(employee[param]);
    });
    return result.toFixed(2);
  }
  if (type === 'payroll') {
    arr = ['baseSalary', 'addBenefits', 'varBenefits'];
    arr.forEach(param => {
      if (!isNaN(employee[param])) result += Number(employee[param]);
    });
    employee.grossSalary = result.toFixed(2);
    return result.toFixed(2);
  }
  if (type === 'absence') {
    arr = ['personalHolidays', 'illnessAccidentDoctor', 'militaryCivilService', 'maternityPaternityLeave', 'publicOffices', 'vocationalSchool'];
    arr.forEach(param => {
      if (!isNaN(employee[param])) result += Number(employee[param]);
    });
    return result.toFixed(2);
  }
  if (type === 'nonOrderRelatedAttendance') {
    arr = ['educationTraining', 'advertisingAcquisition', 'contest', 'managementLeadership', 'edvOperation', 'others'];
    arr.forEach(param => {
      if (!isNaN(employee[param])) result += Number(employee[param]);
    });
    employee.nonOrderRelatedAttendance = result.toFixed(2);
    return result.toFixed(2);
  }
  if (type === 'orderRelatedAttendance') {
    const yearlyPresence = Number(calculateTotal(employee, 'yearlyPresenceTime'));
    const nonOrder = Number(calculateTotal(employee, 'nonOrderRelatedAttendance'));
    const value = yearlyPresence - nonOrder;
    employee.orderRelatedAttendance = value.toFixed(2);
    return value.toFixed(2);
  }
};
var _default = exports.default = calculateTotal;